import React, { useState, Fragment } from 'react';
import { Button } from 'reactstrap';
import { UploadImagesForm } from './UploadImagesForm';
import { faPlus, faBan } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
export default function UploadImagesButton({
    id,
    propertyId,
    bmb,
    userName,
    parentLoadData,
    parentBmbData,
    selectedFolder,
    locale
}) {
    const [isUpdating, setIsUpdating] = useState(false);

    return (
        <Fragment>
            <Button
                color="primary"
                outline
                className=" ml-2"
                size="xs"
                onClick={() => setIsUpdating(!isUpdating)}
            >
                <FontAwesomeIcon icon={faPlus} />
                <span> </span>
                Upload Images
            </Button>

            {isUpdating && (
                <UploadImagesForm
                    id={id}
                    userName={userName}
                    toggleModal={() => {
                        setIsUpdating(!isUpdating);
                    }}
                    formLabel="Upload Images"
                    visible={isUpdating}
                    propertyId={propertyId}
                    bmb={bmb}
                    parentLoadData={parentLoadData}
                    parentBmbData={parentBmbData}
                    selectedFolder={selectedFolder}
                    locale={locale}
                />
            )}
        </Fragment>
    );
}

